import { defineStore } from "pinia"
import type { Viewpoint } from "./types/viewpoints"

export type AppStore = {
    appId: string
    /* googleAnalyticsId: string
    cookiePermissions: {
        [k: string]: boolean
        technical: boolean
        analytical: boolean
        functional: boolean
    } */
    viewReady: boolean
    viewRightReady: boolean
    dev: boolean
    isDragging: boolean
    isMeshLayerActivated: boolean
    sourcesPath: string
    tokensPath: string
    sources: {
        [k: string]: string
    }
    tokens: {
        [k: string]: string
    }
    activeViewpoint: Viewpoint | null
}

const useStore = defineStore("main", {
    state: (): AppStore => {
        return {
            appId: "langweiluv-model",
            //googleAnalyticsId: "G-74Z6X26SV8",
            /* cookiePermissions: {
                technical: true,
                analytical: false,
                functional: false
            }, */
            viewReady: false,
            viewRightReady: false,
            dev: false,
            sourcesPath: "",
            tokensPath: "",
            sources: {},
            tokens: {},
            isDragging: false,
            isMeshLayerActivated: false,
            activeViewpoint: null,
        }
    },
})
export { useStore }
